export default function TeamHandler() {
    const teamMembers = document.querySelectorAll('[data-team-href]');
    const mainContainer = document.querySelector('.main__container');

    function scrollTo(el) {
        const elementPosition = el.getBoundingClientRect().top;
        
        const headerOffset = parseFloat(window.getComputedStyle(mainContainer).paddingTop);
        
        window.scrollTo({
            top: elementPosition + window.pageYOffset - headerOffset,
            behavior: 'smooth'
        });
    }

    if (teamMembers) {
        [].forEach.call(teamMembers, teamLink => {
            teamLink.addEventListener('click', () => {
                const target = document.querySelector(`[data-team-member="${teamLink.dataset.teamHref}"]`);
                scrollTo(target);
            });
        });
    }
}